import { createContext } from "react";

import { WebhookContextTypes } from "./types";

export const WebhookContext = createContext<WebhookContextTypes | undefined>(undefined);
WebhookContext.displayName = "WebhookContext";
